import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const { refresh } = useAuth();
  const [state, setState] = useState("checking");
  useEffect(() => {
    const sid = params.get("session_id");
    if (!sid) return setState("error");
    let tries = 0;
    let stop = false;
    const poll = async () => {
      if (stop) return;
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") { setState("paid"); refresh(); return; }
        if (data.status === "expired") return setState("error");
      } catch (e) { /* retry */ }
      if (++tries < 15) setTimeout(poll, 2000); else setState("timeout");
    };
    poll();
    return () => { stop = true; };
  }, [params, refresh]);
  return (
    <div data-testid="payment-success-page" className="max-w-lg mx-auto text-center py-20 reveal">
      {state === "checking" && <><Loader2 className="mx-auto animate-spin text-[var(--hub)]" size={48} /><h1 className="font-display text-3xl font-bold mt-6">Confirming your payment…</h1></>}
      {state === "paid" && <><CheckCircle2 className="mx-auto text-emerald-400" size={56} /><h1 data-testid="payment-status-paid" className="font-display text-4xl font-black mt-6">Payment confirmed</h1><p className="text-zinc-400 mt-2">Thank you! Your invoice is available in your dashboard.</p></>}
      {(state === "error" || state === "timeout") && <><XCircle className="mx-auto text-red-400" size={56} /><h1 data-testid="payment-status-error" className="font-display text-3xl font-bold mt-6">{state === "timeout" ? "Still processing" : "Payment not completed"}</h1><p className="text-zinc-400 mt-2">Check your dashboard billing tab in a minute.</p></>}
      <Link to="/dashboard?tab=billing" data-testid="payment-go-dashboard" className="inline-flex mt-8 h-11 px-6 items-center rounded-full bg-white text-black font-semibold">Go to dashboard</Link>
    </div>
  );
}

export function PaymentCancel() {
  return (
    <div data-testid="payment-cancel-page" className="max-w-lg mx-auto text-center py-20">
      <XCircle className="mx-auto text-zinc-500" size={56} />
      <h1 className="font-display text-3xl font-bold mt-6">Checkout cancelled</h1>
      <p className="text-zinc-400 mt-2">No charge was made.</p>
      <Link to="/pricing" className="inline-flex mt-8 h-11 px-6 items-center rounded-full bg-white text-black font-semibold">Back to pricing</Link>
    </div>
  );
}
